module.exports = __webpack_public_path__ + "img/ico-map-on.8be561ac.svg";